import React, {Component} from 'react';

import TipoUsuario from './../api/TipoUsuario'; 

const tipoUsuario = new TipoUsuario(); 

class SelectTipoUsuario extends Component {
    constructor(){
        super();
        this.state = {
            listado : [],
        }
    }
    
    async componentDidMount () {

        let listado = await tipoUsuario.resumen(); 
        this.setState({listado: listado}); 

    }

    render(){
        const {tipo, maneja, invalido} = this.props; 
        const {listado} = this.state;

        return (
            <span>
                 <select className={"mb-2 select-cuerpo "+(invalido ? 'in-error' : '')}  onChange={maneja} value={tipo} >
                    <option>Seleccione</option>
                    {
                        listado.map(l => {
                            return <option key={l.id} value={l.id}>{l.nombre}</option>
                        })
                    }
                </select>
            </span>
        )
    }
};

export default SelectTipoUsuario;